module.exports = __webpack_public_path__ + "static/img/wenhua12.46dcbb3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wenhua12.jpg
// module id = pYEq
// module chunks = 1